import { combineReducers } from 'redux';
import { REDUCER_NAME as CREDIT_TERMS_REDUCER_NAME } from './creditTerms/constants';
import { REDUCER_NAME as INVOICES_REDUCER_NAME } from './invoices/constants';
import { REDUCER_NAME as TRANSACTIONS_REDUCER_NAME } from './transactions/constants';
import { REDUCER_NAME as PAYABLES_REDUCER_NAME } from './payables/constants';
import { REDUCER_NAME as DASHBOARD_REDUCER_NAME } from './dashboard/constants';
import { REDUCER_NAME as RECONCILIATION_REDUCER_NAME } from './reconciliation/constants';

import creditTermsReducer from './creditTerms/reducer';
import transactionsReducer from './transactions/reducer';
import payablesReducer from './payables/reducer';
import reconciliationReducer from './reconciliation/reducer';
import invoicesReducer from './invoices/reducer';
import dashboardReducer from './dashboard/reducer';

export default combineReducers({
  [DASHBOARD_REDUCER_NAME]: dashboardReducer,
  [INVOICES_REDUCER_NAME]: invoicesReducer,
  [CREDIT_TERMS_REDUCER_NAME]: creditTermsReducer,
  [TRANSACTIONS_REDUCER_NAME]: transactionsReducer,
  [PAYABLES_REDUCER_NAME]: payablesReducer,
  [RECONCILIATION_REDUCER_NAME]: reconciliationReducer,
});
